import React from 'react';
import { formatDate, parseDate } from '../../utils/constants';

function GenericCard({ title, fields, data, onChange }) {
  const handleChange = (field, value) => {
    onChange({ [field]: parseDate(value) });
  };

  return (
    <div className="data-card">
      <div className="card-header">
        <h3>{title}</h3>
      </div>
      <div className="card-body">
        {Object.entries(fields).map(([key, label]) => (
          <div key={key} className="card-field">
            <div className="field-label">{label}</div>
            <input
              type="text"
              className="field-input"
              value={formatDate(data[key]) ?? ''}
              onChange={(e) => handleChange(key, e.target.value)}
              placeholder="No disponible"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default GenericCard;
